import { AdminMessage } from "@features/atoms/AdminMessage"
import { InlineVideo } from "@features/atoms/InlineVideo"
import { ResponsiveImage } from "@features/atoms/ResponsiveImage"
import { Appear } from "@features/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Inline Media",
  tags: ["#page", "#inline"],
}

export default defineBlock("media/inline-media", (props) => {
  const El = props.link?.url ? Link : "div"
  const elProps = props.link?.url ? { href: props.link.url, target: props.link.target || undefined } : {}
  const image = props.image
  const imageMobile = props.imageMobile
  const video = props.video
  const videoMobile = props.videoMobile

  return (
    <Appear className="inline-media flex content-sized block-spacing">
      {env.admin && !image && !video ? (
        <AdminMessage>Add media in the right panel</AdminMessage>
      ) : (
        <div className="w-full flex flex-col gap-3">
          <El {...elProps} className="inline-media-wrap w-full">
            {imageMobile?.mediaItemUrl && !video?.mediaItemUrl && !videoMobile?.mediaItemUrl && (
              <ResponsiveImage
                {...imageMobile}
                className={cn("inline-media-item w-full", image?.mediaItemUrl && "md:hidden")}
              />
            )}
            {image?.mediaItemUrl && !video?.mediaItemUrl && !videoMobile?.mediaItemUrl && (
              <ResponsiveImage
                {...image}
                className={cn("inline-media-item w-full", imageMobile?.mediaItemUrl && "hidden md:block")}
              />
            )}
            {videoMobile?.mediaItemUrl && (
              <InlineVideo
                src={videoMobile.mediaItemUrl}
                className={cn("inline-media-item", video?.mediaItemUrl && "md:hidden")}
              />
            )}
            {video?.mediaItemUrl && (
              <InlineVideo
                src={video.mediaItemUrl}
                className={cn("inline-media-item", videoMobile?.mediaItemUrl && "hidden md:block")}
              />
            )}
          </El>
          <EditableText
            tag="p"
            store="inlineMediaCaption"
            className="inline-media-caption type-body-xxs w-full text-blue-light !my-0"
            placeholder="Add an optional caption"
          />
        </div>
      )}
    </Appear>
  )
})
